export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "3e63928.worker.js");
}
